import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './useAuth';

type Role = 'admin' | 'dept_admin' | 'member' | 'auditor';

interface Props {
  roles: Role[];
  redirectTo?: string;
  children: React.ReactNode;
}

/**
 * 路由级角色守卫。后端 /admin/* 已用 requireScope 强制 RBAC;本组件只负责前端 UX:
 * 让无权角色直链访问时落到指定路径(默认 /403)。
 */
export function RoleGate({ roles, redirectTo, children }: Props) {
  const { role, isLoading } = useAuth();
  if (isLoading) return null;
  if (!role || !roles.includes(role)) {
    return <Navigate to={redirectTo || '/403'} replace />;
  }
  return <>{children}</>;
}
